import { ActionMap } from '@/store/store.interface';

import { HeaderPayloadType, HeaderActions, HeaderType } from './header.interface';

export type HeaderActionsType = ActionMap<HeaderPayloadType>[keyof ActionMap<HeaderPayloadType>];

export const HeaderReducer = (state: HeaderType, action: HeaderActionsType) => {
  switch (action.type) {
    case HeaderActions.UpdateHeight:
      return {
        ...state,
        height: action.payload,
      };
    default:
      return state;
  }
};
